export default "__VITE_ASSET__3b8b41af__"